import Collection from './collection.js';
import Payslip from 'newModels/payslip.js';

export default class Payslips extends Collection {
    url() {
        if (this.payroll) {
            return `${this.payroll.url()}/slips`;
        }

        if (this.employee) {
            return `${this.employee.url()}/payslips`;
        }

        return `/Payslips`;
    }

    initialize(models, {payroll = null, employee = null}) {
        this.model = Payslip;
        this.payroll = payroll;
        this.employee = employee;
        super.initialize(...arguments);
        if (!this.options.sortKey) {
            this.options.sortKey = 'employeeName';
        }
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/payslips.js